module.exports = require('./helpers/bundle-url').getBundleURL('cS5WQ') + "logo-dark.eefe0b7f.svg";